import { routesPath } from '@router/routes';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { UserRoles } from '@dynamika-shared/types/auth';
import { Layout } from '@components/Layout/Layout';
import { SubjectList } from 'src/pages/ExternalUser/SubjectList/SubjectList';
import { SubjectDetail } from 'src/pages/ExternalUser/SubjectDetail/SubjectDetail';
import { ExternalUserMenu } from '@components/Sidebar/Menu/ExternalUserMenu/ExternalUserMenu';
import { SelectClinicalTrialForRole } from '@components/LoginSelections/SelectClinicalTrialForRole';
import { SiteUserLayout } from '@components/SiteUserLayout/SiteUserLayout';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';

const ReadingTaskViewerPage = lazy(
  () => import('src/pages/Readings/ReadingTaskPage/ReadingTaskViewerPage')
);
const ReaderPlainForm = lazy(
  () => import('src/pages/Readings/ReadingTaskPage/ReaderPlainForm')
);
const ReadingTaskViewerPageDetached = lazy(
  () =>
    import('src/pages/Readings/ReadingTaskPage/ReadingTaskViewerPageDetached')
);

export const ExternalUserRoutes = [
  {
    path: routesPath.externalUserSubjects,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <SiteUserLayout>
          <SelectClinicalTrialForRole />
        </SiteUserLayout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserSubjectsClinicalTrial,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Layout menuComponent={ExternalUserMenu}>
          <SubjectList />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserSubjectDetail,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Layout menuComponent={ExternalUserMenu}>
          <SubjectDetail />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserSubjectDetailClinicalTrial,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Layout menuComponent={ExternalUserMenu}>
          <SubjectDetail />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserTaskViewer,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPage />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserSubTaskViewer,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPage />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserTaskPlain,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReaderPlainForm />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserTaskViewerDetached,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPageDetached />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.externalUserSubTaskViewerDetached,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.EXTERNAL_USER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPageDetached />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
];
